module.exports = __webpack_public_path__ + "static/img/蓝.dacba3c.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/蓝.svg
// module id = Zd1H
// module chunks = 88